import { Users, CheckCircle2 } from "lucide-react";
import { Reveal } from "../site/Reveal";
import { useSiteContent } from "@/context/SiteContentContext";

export const Community = () => {
  const { home } = useSiteContent();
  const community = home.community;
  return (
    <section data-testid="community-section" className="relative overflow-hidden bg-aero-surface">
      <div className="mx-auto max-w-[1400px] px-5 py-20 sm:px-8 sm:py-28">
        <div className="grid items-center gap-12 lg:grid-cols-[1fr_1.1fr] lg:gap-16">
          <div>
            <Reveal>
              <div className="mb-6 flex items-center gap-3">
                <Users className="h-6 w-6 text-saffron" />
                <span className="font-heading text-xs uppercase tracking-[0.28em] text-saffron">
                  Community & Partnerships
                </span>
              </div>
              <h2 className="font-heading text-4xl font-bold leading-[1.05] tracking-tight text-ink sm:text-5xl">
                {community.heading}
              </h2>
              <p className="mt-6 max-w-xl font-body text-base leading-relaxed text-steel">
                {community.body}
              </p>
            </Reveal>

            <ul className="mt-8 space-y-4">
              {(community.points || []).map((point, i) => (
                <Reveal key={i} delay={i * 0.08}>
                  <li className="flex items-center gap-3">
                    <CheckCircle2 className="h-5 w-5 shrink-0 text-saffron" />
                    <span className="font-body text-sm text-ink">{point}</span>
                  </li>
                </Reveal>
              ))}
            </ul>
          </div>

          <Reveal delay={0.15}>
            <div className="relative">
              <div className="overflow-hidden rounded-2xl border border-steel/20">
                <img
                  src={community.image || "/amai-community.jpeg"}
                  alt="AMAI aeromodelling community — field day with model aircraft"
                  className="aspect-[5/4] w-full object-cover"
                />
              </div>
              <div className="absolute -bottom-5 left-6 rounded-xl border border-saffron/40 bg-aero-navy px-6 py-4">
                <p className="font-heading text-2xl font-black text-saffron">{community.badgeTitle || "AMAI"}</p>
                <p className="font-body text-xs text-steel">
                  {community.badgeText || "Aeromodellers' Association India (Jodhpur's members)"}
                </p>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
